import { createJourneyEngineSetting, getJourneyEngineSettingsList, removeFromJourneyEngineSettingsList, rollbackJourney, updateJourneyEngineSettingsList } from './io';
import { Promise } from 'es6-promise';
import types from '../store/types';
import store from '../store/store';
import { IdHelper, IJourneyItem, IAdminToolPanel, AdminToolPanelHelper, UpgradeHelper, AdminToolHelper, JESettingsListData, IJESettingsSidebar } from './';
import { PANEL_VALUE_JESETTINGS_LIST } from '../constants';
declare var jQuery;

export class JourneyEngineSettingsHelper {

    /**
* List of upgrades
* @static
* @memberOf AdminToolHelper
*/
    public static getJESettingsList(panelName: any): Promise<any> {
        let promise = new Promise<any>((resolve, reject) => {
            getJourneyEngineSettingsList().then(
                (response) => {
                    // response = response.sort(function (a, b) {
                    //     return a.keyField - b.keyField;
                    // })

                    // response = response.sort((a, b) => a.keyField - b.keyField);
                    response = response.sort((a, b) => {

                        if (a.keyField.toLowerCase() < b.keyField.toLowerCase()) {
                            return -1;
                        }

                        if (a.keyField.toLowerCase() > b.keyField.toLowerCase()) {
                            return 1;
                        }

                        return 0;

                    });

                    AdminToolPanelHelper.AddOrUpdatePanelValue(panelName, PANEL_VALUE_JESETTINGS_LIST, response);
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });

        return promise;
    }

    public static updateFromJESettingsList(panelName: string, jesetting: JESettingsListData): Promise<any> {
        let jesettingToUpdate = JSON.stringify(jesetting);
        let req = {
            "jesettingsJSON": jesettingToUpdate,
            "Id": jesetting.journeyEngineSettingsId
        }

        let promise = new Promise<any>((resolve, reject) => {
            updateJourneyEngineSettingsList(req).then(
                (response) => {

                    var isJESettingsList: boolean = true;
                    AdminToolHelper.getAdminToolList(panelName, isJESettingsList).then(() => {
                        AdminToolPanelHelper.SetPanelIsLoading(panelName, false);
                        AdminToolHelper.ClearProcessList();
                    });

                    // remove error message
                    AdminToolHelper.SetJESettingsSidebarError(null);

                    // show success message
                    AdminToolHelper.SetJESettingsSidebarSuccess(true);

                    // hide success message
                    var test = setTimeout(() => {
                        AdminToolHelper.SetJESettingsSidebarSuccess(false);
                    }, 1500);
                    resolve(response);
                },
                (error) => {

                    // remove success message
                    AdminToolHelper.SetJESettingsSidebarSuccess(false);

                    // show error message
                    AdminToolHelper.SetJESettingsSidebarError(error && error.error && error.error.message);

                    reject(error);
                }
            );
        });

        return promise;
    }

    public static addToJESettingsList(panelName: string, jesetting: JESettingsListData): Promise<any> {
        let jesettingToCreate = JSON.stringify(jesetting);
        // let req = {
        //     "jesettingsJSON": "{\"JourneyEngineSettingsId\":\"82FAE163-8019-E911-A95E-000D3AB6D103\",\"KeyField\":\"KeyField Modified\",\"NameField\":\"NameField Modified\"}",
        //     "Id": "82FAE163-8019-E911-A95E-000D3AB6D103"
        // }
        let req = {
            "jesettingsJSON": jesettingToCreate,
            "Id": "00000000-0000-0000-0000-000000000000"
        }

        let promise = new Promise<any>((resolve, reject) => {
            createJourneyEngineSetting(req).then(
                (response) => {

                    var isJESettingsList: boolean = true;
                    AdminToolHelper.getAdminToolList(panelName, isJESettingsList).then(() => {
                        AdminToolPanelHelper.SetPanelIsLoading(panelName, false);
                        AdminToolHelper.ClearProcessList();
                    });

                    // remove error message
                    AdminToolHelper.SetJESettingsSidebarError(null);

                    // reset form values
                    AdminToolHelper.resetJourneyEngineSettingsList();

                    // show success message
                    AdminToolHelper.SetJESettingsSidebarSuccess(true);

                    // hide success message
                    var test = setTimeout(() => {
                        AdminToolHelper.SetJESettingsSidebarSuccess(false);
                    }, 1500);
                    resolve(response);
                },
                (error) => {

                    // show success message
                    AdminToolHelper.SetJESettingsSidebarSuccess(false);

                    // remove error message
                    AdminToolHelper.SetJESettingsSidebarError(error && error.error && error.error.message);

                    reject(error);
                }
            );
        });

        return promise;
    }

    public static validateSidebarForm(jesetting: JESettingsListData) {
        let missingRequiredFields = [];
        if (!(jesetting && jesetting.nameField)) {
            missingRequiredFields.push('Name');
        }
        if (!(jesetting && jesetting.keyField)) {
            missingRequiredFields.push('Key');
        }
        if (missingRequiredFields.length) {
            AdminToolHelper.SetSidebarFormValidationError(missingRequiredFields);
            return false;
        } else {
            AdminToolHelper.SetSidebarFormValidationError(missingRequiredFields);
            return true;
        }


    }
    public static removeFromJESettingsList(panelName: any, JourneyEngingeSettingsId: string): Promise<any> {
        let promise = new Promise<any>((resolve, reject) => {
            removeFromJourneyEngineSettingsList(JourneyEngingeSettingsId).then(
                (response) => {

                    alert("Record deleted successfully.");

                    var isJESettingsList: boolean = true;
                    AdminToolHelper.getAdminToolList(panelName, isJESettingsList).then(() => {
                        AdminToolPanelHelper.SetPanelIsLoading(panelName, false);
                        AdminToolHelper.ClearProcessList();
                    });

                    resolve(response);
                },
                (error) => {

                    alert(error && error.error && error.error.message);

                    reject(error);
                }
            );
        });

        return promise;
    }


    /**
    *  Start the journey rollback process.
    *  This method calls CallRollback method for every
    *  process item.
    * @static
    * @memberOf JourneyRollbackHelper
    **/
    // public static StartUpRollbackProcess(processList: any,) {
    //     let getState: any = store.getState();
    //     let journeyId: string = getState.adminToolState.processList[getState.adminToolState.tab][0].journeyId;
    //     let rollbackToUpgradeId: string = getState.adminToolState.processList[getState.adminToolState.tab][0].upgradeId;
    //     AdminToolHelper.SetUpgradingProcess(true, journeyId, 0);
    //     JourneyEngineSettingsHelper.CallRollback(rollbackToUpgradeId, journeyId, getState.adminToolState.UpgradeId, (processList[getState.adminToolState.tab].length == 1));
    //     AdminToolHelper.GetLoggingFor(journeyId, getState.adminToolState.UpgradeId, getState.adminToolState.advancedLogging);
    // }


    /**
    *  Calls the rollback API and set 'isprocessing' to true in the state
    * @static
    * @memberOf JourneyRollbackHelper
    **/
    // public static CallRollback(rollbackUpgradeId: any, journeyId: any, upgradeId: string, isFinalRequest: boolean) {
    //     let promise = new Promise<any>((resolve, reject) => {
    //         rollbackJourney(rollbackUpgradeId, journeyId, upgradeId, isFinalRequest).then(
    //             (response) => {
    //                 let getState: any = store.getState();

    //                 AdminToolHelper.UpdateProcessItem(getState.adminToolState.journeyProcessNum, (response.isValid ? "Success" : "Failed"));
    //                 if ((getState.adminToolState.journeyProcessNum + 1) < getState.adminToolState.processList[getState.adminToolState.tab].length && !getState.adminToolState.cancelUpgrade) {
    //                     let journeyNum: number = getState.adminToolState.journeyProcessNum + 1;
    //                     let journeyId: string = getState.adminToolState.processList[getState.adminToolState.tab][journeyNum].journeyId;
    //                     let rollbackToUpgradeId: string = getState.adminToolState.processList[getState.adminToolState.tab][journeyNum].upgradeId;
    //                     AdminToolHelper.SetUpgradingProcess(true, journeyId, journeyNum);
    //                     JourneyEngineSettingsHelper.CallRollback(rollbackToUpgradeId, journeyId, upgradeId, ((journeyNum + 1) == getState.adminToolState.processList[getState.adminToolState.tab].length));
    //                 }
    //                 else {
    //                     if (getState.adminToolState.cancelUpgrade) {
    //                         UpgradeHelper.CancelUpgrade(getState.adminToolState.UpgradeId);
    //                     }
    //                     setTimeout(() => {
    //                         AdminToolHelper.SetUpgradingProcess(false, "", 0);
    //                     }, 1000);
    //                 }
    //             },
    //             (error) => {
    //                 reject(error);
    //             }
    //         );
    //     });
    // }
}


// WEBPACK FOOTER //
// ./source/ts/helpers/journeyenginesettingshelper.ts